<div class="operating-hours-container">
  <div class="heading">{{ 'operating-hours' | translate }}</div>
  <ng-container *ngIf="locationInfo">
    <ng-container *ngFor="let item of locationInfo.operatingHours"
      ><div class="operating-hours">
        <label class="day">{{ item.day | translate }}</label>
        <label class="opening-hours" *ngIf="item.allow"
          >{{ item.startTime | time24to12Transform }} -
          {{ item.endTime | time24to12Transform }}
        </label>
        <label class="opening-hours" *ngIf="!item.allow">{{ 'Closed' | translate }}</label>
      </div>
    </ng-container>
    <ng-container>
      <div class="statutory">
        {{ 'statutory-holidays' | translate }}
      </div>
    </ng-container>
  </ng-container>
</div>
